import { AVAILABILITY_BT_CONSTS } from '~/modules/availability/consts/btConsts';

export const getOnOrderAvailability = (deliverabilityMessage: string, status: string): string => {
  const onOrderStatus = deliverabilityMessage && AVAILABILITY_BT_CONSTS.ON_ORDER_CODES.indexOf(status) !== -1;
  return onOrderStatus ? AVAILABILITY_BT_CONSTS.ON_ORDER : '';
};
export const availabilityStatus = (deliverabilityMessage: string, status: string) => {
  const availableStatus = deliverabilityMessage && AVAILABILITY_BT_CONSTS.AVAILABLE_CODES.indexOf(status) !== -1;
  const available = availableStatus ? AVAILABILITY_BT_CONSTS.AVAILABLE : getOnOrderAvailability(deliverabilityMessage, status);

  return {
    available,
    showUnavailableMessage: !available && AVAILABILITY_BT_CONSTS.UNAVAILABLE_MESSAGES.indexOf(deliverabilityMessage) !== -1,
  };
};
